import { FormEvent, useState } from 'react';
import { RegistrationContainer } from '@bumble/app/components/RegistrationContainer';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Alert, Box, Button, Divider, InputAdornment, TextField, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

export const ForgotPassword = () => {
  const api = useApi();
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);

  const forgotPassword = useMutation(api.forgotPasswordApiV1ForgotPasswordPost, {
    onSuccess() {
      toast.success('Email sent.');
      setSuccess(true);
    },
    onError: apiError,
  });

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    forgotPassword.mutate({
      email,
    });
  };

  if (success) {
    return (
      <RegistrationContainer>
        <Typography variant="h3" component="h1" mb={2}>
          Forgot password?
        </Typography>
        <Alert severity="success" sx={{ textAlign: 'left', my: 5 }}>
          An email confirmation has been sent to your registered email address.
        </Alert>
        <Box py={6}>
          <Divider />
        </Box>
        <Button size="small" variant="text" component={Link} to="/login">
          Already have an account?
        </Button>
      </RegistrationContainer>
    );
  }
  return (
    <RegistrationContainer>
      <Typography variant="h3" component="h1" mb={2}>
        Forgot password?
      </Typography>
      <Typography variant="body1" component="p" py={2} mb={2}>
        Enter your email address below and we&apos;ll send you a password reset.
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Email
          Address"
          margin="normal"
          type="text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon />
              </InputAdornment>
            ),
          }}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Box mt={4}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            type="submit"
            disabled={email.length < 5}
          >
            Send Email
          </Button>
        </Box>
      </Box>
      <Box py={6}>
        <Divider />
      </Box>
      <Button size="small" variant="text" component={Link} to="/login">
        Already have an account?
      </Button>
    </RegistrationContainer>
  );
};
